import domain from "@/environment";
import axios from "axios";

const state = {
  configuration: null,
  configurations: [],
  configurationRows: 0,
  configurationLoading: false,
};

const getters = {
  getLoadingConfiguration: (state) => state.configurationLoading,
  getConfiguration: (state) => state.configuration,
  getAllConfigurations: (state) => state.configurations,
  getTotalRowConfiguration: (state) => state.configurationRows,
};

const mutations = {
  DO_NOTHING() {},
  SET_CONFIGURATION_LOADING(state, payload) {
    state.configurationLoading = payload || false;
  },
  SET_CONFIGURATION(state, payload) {
    state.configuration = payload ? payload : null;
  },
  PUSH_CONFIGURATION(state, payload) {
    state.configurations.push(payload);
  },
  UPDATE_CONFIGURATION(state, payload) {
    for (let index = 0; index < state.configurations.length; index++) {
      if (state.configurations[index].id === payload.id) {
        state.configurations.splice(index, 1, payload);
        break;
      }
    }
  },
  DELETE_CONFIGURATION(state, payload) {
    state.configurations = state.configurations.filter(
      (item) => item.id !== payload.id
    );
  },
  UPDATE_CONFIGURATION_ROW(state, payload) {
    state.configurationRows = payload ? payload : 0;
  },
  SET_CONFIGURATIONS(state, payload) {
    console.log('SET_CONFIGURATIONS mutation called with:', payload);
    state.configurations = payload ? payload : [];
    console.log('State configurations after mutation:', state.configurations);
  },
};

const actions = {
  async allConfigurations({ commit }, payload) {
    commit("SET_CONFIGURATION_LOADING", true);

    const params = {
      page: payload?.page,
      per_page: payload?.per_page,
      entreprise_id: payload?.entreprise_id,
      lib: payload?.lib,
      search: payload?.search,
      entite_externe_id: payload?.entite_externe_id
    };
    try {
      const response = await axios.get(domain + "/config", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });

      console.log('API Response:', response.data);

      let configurationsData = [];
      let totalRows = 0;

      if (response.data && response.data.data) {
        if (Array.isArray(response.data.data)) {
          configurationsData = response.data.data;
          totalRows = response.data.data.length;
        } 
        else if (response.data.data.data && Array.isArray(response.data.data.data)) {
          configurationsData = response.data.data.data;
          totalRows = response.data.data.total || 0;
        }
      } else if (Array.isArray(response.data)) {
        // Si la réponse est directement un array
        configurationsData = response.data;
        totalRows = response.data.length;
      }

      console.log('Configurations Data:', configurationsData);
      console.log('Total Rows:', totalRows);

      commit("SET_CONFIGURATIONS", configurationsData);
      commit("UPDATE_CONFIGURATION_ROW", totalRows);
      commit("SET_CONFIGURATION_LOADING", false);
      return response.data;
    } catch (error) {
      commit("SET_CONFIGURATION_LOADING", false);
      throw error.response ? error.response.data.message : error.message;
    }
  },
  async configuration({ commit }, payload) {
    commit("DO_NOTHING");
    try {
      const response = await axios.get(domain + `/config/` + payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_CONFIGURATION", response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data.message;
    }
  },
  async editConfiguration({ commit }, payload) {
    try {
      let id;
      if (payload instanceof FormData) {
        id = payload.get("id");
      } else {
        id = payload.id;
      }

      if (!id) {
        throw new Error("ID is required for editing configuration");
      }

      // Si type_prix est "pourcentage", mettre les prix à null
      if (payload.type_prix === "pourcentage") {
        payload.prix_cumac_precaire = null;
        payload.prix_cumac_classique = null;
      }

      const headers = {
        Authorization: `Bearer ` + this.state.token,
      };

      if (payload instanceof FormData) {
        headers["Content-Type"] = "multipart/form-data";
      }

      const response = await axios.put(
        domain + `/config/` + id,
        payload,
        {
          headers: headers,
        }
      );

      commit("UPDATE_CONFIGURATION", response.data.data);
      return response.data.data;
    } catch (error) {
      throw error.response && error.response.data
        ? error.response.data.message
        : error.message;
    }
  },
  async storeConfiguration({ commit, state }, payload) {
    try {
      // Si type_prix est "pourcentage", mettre les prix à null
      if (payload.type_prix === "pourcentage") {
        payload.prix_cumac_precaire = null;
        payload.prix_cumac_classique = null;
      }

      const headers = {
        Authorization: `Bearer ` + this.state.token,
      };

      if (payload instanceof FormData) {
        headers["Content-Type"] = "multipart/form-data";
      }

      const response = await axios.post(domain + `/config`, payload, {
        headers: headers,
      });

      commit("PUSH_CONFIGURATION", response.data.data);
      commit("UPDATE_CONFIGURATION_ROW", state.configurationRows + 1);
      return response.data.data;
    } catch (error) {
      throw error.response && error.response.data
        ? error.response.data.message
        : error.message;
    }
  },
  async deleteConfiguration({ commit, state }, payload) {
    commit("SET_CONFIGURATION_LOADING", true);
    try {
      await axios.delete(domain + `/config/` + payload.id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("DELETE_CONFIGURATION", payload);
      commit("UPDATE_CONFIGURATION_ROW", state.configurationRows - 1);

      commit("SET_CONFIGURATION_LOADING", false);
      return true;
    } catch (error) {
      commit("SET_CONFIGURATION_LOADING", false);
      throw error.response.data.message;
    }
  },
};

export default { state, mutations, getters, actions };